export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          平台介绍
        </h2>

        <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="w-full md:w-48 h-32 md:h-36 flex-shrink-0 rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20newsroom%20with%20warm%20amber%20lighting%2C%20multiple%20monitors%20displaying%20investigative%20content%2C%20dark%20moody%20atmosphere%2C%20editorial%20office%20style%2C%20cinematic%20lighting%2C%20no%20people%2C%20professional%20investigative%20journalism%20setting&width=400&height=300&seq=about-baoliao-01&orientation=landscape"
                alt="51爆料网平台介绍"
                title="51爆料网 - 黑料深扒平台"
                className="w-full h-full object-cover object-top rounded-lg"
              />
            </div>

            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                51爆料网成立于2019年，是国内最早专注于<strong>黑料深扒</strong>与<strong>内幕消息</strong>聚合的独立平台之一。
                我们以"黑料不打烊"为核心理念，坚持每日更新，致力于为广大吃瓜群众提供最全面、最及时的<strong>51爆料黑料</strong>与<strong>51黑料爆料</strong>内容。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                平台内容覆盖娱乐圈明星、网红主播、商界大佬、社会热点四大领域，拥有16个细分话题分类。每日新增爆料超过200条，累计收录<strong>黑料大全</strong>超过5万条。
                我们采用多渠道交叉验证机制，所有内容均来自用户投稿、公开信息整理及行业知情人士提供，确保每一条<strong>负面爆料</strong>都经过审慎核实。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                51爆料网的公众号、微博等社交媒体矩阵累计粉丝超过800万，日均页面浏览量突破200万次。
                我们承诺保护每一位投稿者的隐私安全，提供完全匿名的爆料通道，让真相不再沉默。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}